import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

interface Heading {
    style?: { [index: string]: string | number };
    text: string;
    tootlip?: string;
}

class QualityAnalysisTableController implements angular.IComponentController {
    readonly headings: Heading[];
    readonly isLoading: boolean;
    readonly rows: any[]; // to be determined

    static $inject = [];
}

export const wtQualityAnalysisTable: ComponentDefinition = {
    componentId: 'wtQualityAnalysisTable',
    controller: QualityAnalysisTableController,
    template: require('./qualityAnalysisTable.component.html'),
    controllerAs: 'vm',
    transclude: true,
    bindings: {
        headings: '<',
        isLoading: '<',
        rows: '<'
    }
};
